import apiClient from "./APIClient";

export const getTotalRetailers = async () => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-countDownlineAgents?lang=${lang}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const stockPurchaseStats = async (params = {}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-countStockPurchaseStats?lang=${lang}&filterType=${params.filterType}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const stockTransferStats = async ({filterType="monthly"}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-stockTransferStats?lang=${lang}&filterType=${filterType}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const merchantRechargeLogStats = async ({filterType="monthly"}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-getMerchantRechargeLogStats?lang=${lang}&filterType=${filterType}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const productActivationLogStats = async ({filterType="monthly"}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-getProductActivationLogStats?lang=${lang}&filterType=${filterType}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const merchantReverseStockStats = async ({filterType = "monthly"}) => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-getMerchantReverseStockStats?lang=${lang}&filterType=${filterType}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const merchantTicketStats = async ({ startDate, endDate }) => {
  const lang = localStorage.getItem("i18nextLng");
   const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    params.append("lang", lang);
  try {
    const res = await apiClient.get(
      `statistics/merchant-getMerchantTicketStats?${params.toString()}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const revenueStatsForMerchant = async () => {
  const lang = localStorage.getItem("i18nextLng");
  try {
    const res = await apiClient.get(
      `statistics/merchant-revenueStatsForMerchant?lang=${lang}`
    );
    console.log(res);
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

